// Display-only tool catalog. Mirrors proto/mecharena/v1/game.proto
// ToolId enum and is used to label events in the viewer. Kept tiny on
// purpose — the resolver's damage formula lives in server/, not here.

export interface ToolInfo {
  id: number;
  short: string;
  kind: "movement" | "direct_fire" | "missile" | "melee" | "utility" | "sensor";
}

export const TOOLS: ToolInfo[] = [
  { id: 1, short: "Walk", kind: "movement" },
  { id: 2, short: "Dash", kind: "movement" },
  { id: 3, short: "Jump", kind: "movement" },
  { id: 4, short: "MedLaser", kind: "direct_fire" },
  { id: 5, short: "AC", kind: "direct_fire" },
  { id: 6, short: "PPC", kind: "direct_fire" },
  { id: 7, short: "LRM", kind: "missile" },
  { id: 8, short: "Punch", kind: "melee" },
  { id: 9, short: "Smoke", kind: "utility" },
  { id: 10, short: "Coolant", kind: "utility" },
  { id: 11, short: "Scan", kind: "sensor" },
  { id: 12, short: "TargetLock", kind: "sensor" },
];

const BY_ID = new Map(TOOLS.map((t) => [t.id, t]));

export function toolShortLabel(id: number): string {
  return BY_ID.get(id)?.short ?? `tool ${id}`;
}

export function toolKind(id: number): ToolInfo["kind"] | null {
  return BY_ID.get(id)?.kind ?? null;
}
